import React from 'react';
import RedMadevi from 'assets/images/svg/RedMadevi.svg';
import PlayIcon from 'assets/images/svg/Play.svg';

const ViewIcon = ({ className }: { className?: string }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M4.81922 1.92769C4.69141 1.92769 4.56883 1.97846 4.47845 2.06884C4.38807 2.15922 4.3373 2.2818 4.3373 2.40961V7.22883C4.3373 7.35665 4.38807 7.47923 4.47845 7.5696C4.56883 7.65998 4.69141 7.71076 4.81922 7.71076C4.94704 7.71076 5.06961 7.65998 5.15999 7.5696C5.25037 7.47923 5.30114 7.35665 5.30114 7.22883V2.40961C5.30114 2.2818 5.25037 2.15922 5.15999 2.06884C5.06961 1.97846 4.94704 1.92769 4.81922 1.92769ZM2.40961 4.81922C2.2818 4.81922 2.15922 4.87 2.06884 4.96037C1.97846 5.05075 1.92769 5.17333 1.92769 5.30114V7.22883C1.92769 7.35665 1.97846 7.47923 2.06884 7.5696C2.15922 7.65998 2.2818 7.71076 2.40961 7.71076C2.53742 7.71076 2.66 7.65998 2.75038 7.5696C2.84076 7.47923 2.89153 7.35665 2.89153 7.22883V5.30114C2.89153 5.17333 2.84076 5.05075 2.75038 4.96037C2.66 4.87 2.53742 4.81922 2.40961 4.81922ZM7.22883 3.85538C7.10102 3.85538 6.97844 3.90615 6.88806 3.99653C6.79768 4.08691 6.74691 4.20949 6.74691 4.3373V7.22883C6.74691 7.35665 6.79768 7.47923 6.88806 7.5696C6.97844 7.65998 7.10102 7.71076 7.22883 7.71076C7.35665 7.71076 7.47923 7.65998 7.5696 7.5696C7.65998 7.47923 7.71076 7.35665 7.71076 7.22883V4.3373C7.71076 4.20949 7.65998 4.08691 7.5696 3.99653C7.47923 3.90615 7.35665 3.85538 7.22883 3.85538ZM8.19268 0H1.44577C1.06233 0 0.694589 0.152321 0.423455 0.423455C0.152321 0.694589 0 1.06233 0 1.44577V8.19268C0 8.57612 0.152321 8.94386 0.423455 9.21499C0.694589 9.48612 1.06233 9.63844 1.44577 9.63844H8.19268C8.57612 9.63844 8.94386 9.48612 9.21499 9.21499C9.48612 8.94386 9.63844 8.57612 9.63844 8.19268V1.44577C9.63844 1.06233 9.48612 0.694589 9.21499 0.423455C8.94386 0.152321 8.57612 0 8.19268 0ZM8.6746 8.19268C8.6746 8.32049 8.62383 8.44307 8.53345 8.53345C8.44307 8.62383 8.32049 8.6746 8.19268 8.6746H1.44577C1.31795 8.6746 1.19537 8.62383 1.105 8.53345C1.01462 8.44307 0.963844 8.32049 0.963844 8.19268V1.44577C0.963844 1.31795 1.01462 1.19537 1.105 1.105C1.19537 1.01462 1.31795 0.963844 1.44577 0.963844H8.19268C8.32049 0.963844 8.44307 1.01462 8.53345 1.105C8.62383 1.19537 8.6746 1.31795 8.6746 1.44577V8.19268Z" fill="currentColor" />
  </svg>
);

interface MarketCardLayout2Props {
  colors: {
    background: string;
    text: string;
    button: string;
    buttonText: string;
    status: string;
    border: string;
  };
}

const MarketCardLayout2: React.FC<MarketCardLayout2Props> = ({ colors }) => {
  return (
    <div className="rounded-2xl border border-[#e5e7eb] shadow-md bg-white">
      <div className="p-3">
        {/* Top row: thumbnail, title, status, play */}
        <div className="flex items-center justify-between gap-1">
          <div className="flex items-center gap-1">
            <img src={RedMadevi} alt="market" className="w-14 h-14 rounded flex-shrink-0" />
            <div className="flex flex-col whitespace-nowrap">
              <div className="flex items-center gap-2 mb-1">
                <div className="font-semibold text-sm text-[#2C4252]">MAHADEVI</div>
                <div className="text-[9px] font-medium text-[#D11A2A]">Market Closed</div>
              </div>

              <div className=" flex items-center gap-1 rounded-md px-1 py-0.5 text-xs border border-[#4B975E] whitespace-nowrap">
                <span className="text-[9px] text-[#2C4252]">Open</span>
                <span className="font-semibold text-[10px] text-[#4B975E]">04:34 PM</span>
                <span className="text-[9px] text-[#2C4252]">Close</span>
                <span className="font-semibold text-[10px] text-[#4B975E]">04:34 PM</span>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-0 flex-shrink-0 pr-8">
            <button type="button" className="rounded-full pt-6">
              <img src={PlayIcon} alt="play" className="w-6 h-6 " /> 
            </button>
          </div>
        </div>

        {/* Result number with View button */}
        <div className="mt-1 ml-16 flex items-center gap-2">
          <div className="font-semibold text-sm text-[#2E7D32]">399-112-78</div>
          <button
            type="button"
            className="ml-4 text-xs font-medium inline-flex items-center gap-1 text-white bg-[#4B975E] rounded-md px-2 py-0.5"
          >
            <ViewIcon className="w-3 h-3 text-white" />
            View
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketCardLayout2;
